module.exports = __webpack_public_path__ + "img/1.57f4778f.jpg";